import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import APP_CONSTANTS from "../../config/constants";
import Axios from "axios";
import $ from "jquery";
import ReadAxios, { CommonGetApi } from "../axiosComponent/read";
//import { update } from "js-sha512";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";

const MyVehicle = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const errorText = touched[name] && errors[name];
  const [content, setcontent] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    handleSearch();
  }, [props.vehId]);
  let handleSearch = () => {
    setloading(true);
    // let searchTerm = data.searchQuery
    allAxiosCommonRequest({
      url: `vendorMaster/vehicles/${props.vehId}`,
      method: "get",
    }) //CommonGetApi({ url: `vendorMaster/vehicles/${props.vehId}` })
      .then((result) => {
        // console.log(result)
        setcontent(result);
        setloading(false);
      });
  };
  let options = [];
  if (content && content.length > 0) {
    content.map((object, index) => {
      let temp = {};
      temp.key = object.vehicleNumber;
      temp.text = object.vehicleNumber;
      temp.value = object.vehicleNumber.toLowerCase();
      return (options[index] = temp);
    });
    content.map((o, i) => {
      props.vehicleType({
        vehtype: o.vehicleType,
        vehtypId: o.vehicleTypeId,
        vehtypeCode: o.vehicleTypeCode,
      });
    });
  }

  const updateFiledValue = (name, data) => {
    setFieldValue(name, data.value);
  };

  return (
    <Dropdown
      selection
      loading={loading ? true : false}
      style={{ width: "100%" }}
      onChange={(value, data) => setFieldValue(name, data.value)}
      options={options}
      {...props}
    />
  );
};

export default MyVehicle;
